export const data = [
  {
    id: 234,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1742382133/Screenshot_5_bqdywf.png",
    host: "https://curosity-closet.vercel.app",
    title: "Shopping cart",
    github: "https://github.com/Abhishek-Singh2003/Curosity-Closet---Frontend",
  },
  {
    id: 18,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1741113429/Screenshot_32_a7yamp.png",
    host: "https://abhi-hospital.netlify.app/",
    title: "City hospital",
    github: "https://github.com/Abhishek-Singh2003/City-Hospital",
  },
  {
    id: 6,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1741368546/Screenshot_34_pikoxt.png",
    host: "https://abhi-camera.netlify.app/",
    title: "Lens Pulse",
    github: "https://github.com/Abhishek-Singh2003/Lens-Pulse",
  },
  {
    id: 908,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1742398450/Screenshot_6_pxa6sd.png",
    host: "https://abhi-2003.netlify.app/",
    title: "Portfolio",
    github: "https://github.com/Abhishek-Singh2003/Abhi-portfolio",
  },
  {
    id: 8,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1740759406/Screenshot_21_q6ores.png",
    host: "https://votingapp1.netlify.app/ ",
    title: "Vote Sphere",
    github: "https://github.com/Abhishek-Singh2003/Vote-sphere",
  },
  {
    id: 5,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1740846784/Screenshot_25_r4y1mc.png",
    host: "https://abhi-resturant.netlify.app/",
    title: "Food Delight",
    github: "https://github.com/Abhishek-Singh2003/Food-delight",
  },
  {
    id: 9,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1769625799/Screenshot_2026-01-29_001256_xhltyr.png",
    host: "https://carrer-page.netlify.app/",
    title: "Search Your Dream Job",
    github: "https://github.com/Abhishek-Singh2003/Carrer-Page-",
  },
  {
    id: 77,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1769626018/Screenshot_2026-01-29_001636_qzthk1.png",
    host: "https://abhi-forecast-weather.netlify.app/",
    title: "Weather Forecast",
    github: "https://github.com/Abhishek-Singh2003/Weather-forecast",
  },
  {
    id: 7,
    img: "https://res.cloudinary.com/dixdiy3uj/image/upload/v1740907741/Screenshot_27_xgype2.png",
    host: "https://abhi-gallery1.netlify.app/",
    title: "Gallery",
    github: "https://github.com/Abhishek-Singh2003/Gallery",
  },

];

export const moreData = [

  // {
  //   id: 22,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1654271179/rest_hwoctn.png",
  //   host: "https://resturant123iakobidze.netlify.app/#categories",
  //   title: "Resturant page",
  //   github: "https://github.com/levaniakobidze/resturant-landing-page",
  // },
  // {
  //   id: 2,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1649954893/users_q4ebfs.png",
  //   host: "https://githubsearch12.netlify.app/",
  //   title: "Users search",
  //   github: "https://github.com/levaniakobidze/Github-Users",
  // },
  // {
  //   id: 517,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1660495945/filters_buan9x.png",
  //   host: "https://products-filter-js-theta.vercel.app/",
  //   title: "Product Filter (JS)",
  //   github: "https://github.com/levaniakobidze/Products-filter",
  // },

  // {
  //   id: 1,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1649954772/landing_v1fmpo.png",
  //   host: "https://travel-page1.netlify.app/",
  //   title: "Travel page",
  //   github: "https://github.com/levaniakobidze/Travel-page",
  // },
  // {
  //   id: 90,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1656315158/checkout_ncnj8h.png",
  //   host: "https://checkout-page-livid.vercel.app/",
  //   title: "Chekout Page",
  //   github: "https://github.com/levaniakobidze/Checkout-page",
  // },
  // {
  //   id: 4,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1650570209/quotes_wqtojq.png",
  //   host: "https://quotes-generator12.netlify.app/",
  //   title: "Quotes generator",
  //   github: "https://github.com/levaniakobidze/React-Random-Quotes",
  // },
  // {
  //   id: 3,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1650569021/landing-page_fcq4fi.png",
  //   host: "https://landingpage1223.netlify.app/",
  //   title: "Landing page",
  //   github: "https://github.com/levaniakobidze/Landing-page",
  // },
  // {
  //   id: 88,
  //   img: "https://res.cloudinary.com/diyky5uya/image/upload/v1657298802/landing1_rkgteo.png",
  //   host: "https://test-project12.vercel.app/",
  //   title: "Landing page (API)",
  //   github: "https://github.com/levaniakobidze/tech-test-landing-page-api",
  // },
];